// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-components-Calendar-___Calendar-module__container {
  width: 314px;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
  overflow: hidden;
}

.app-components-Calendar-___Calendar-module__header {
  display: flex;
  /* flex-direction: column; */
  /* padding: 15px 25px; */
  background-color: var(--colors-yuzu-primaryColor);
  color: var(--colors-yuzu-black);
}

.app-components-Calendar-___Calendar-module__headerDate {
  display: flex;
  flex-direction: column;
  padding: 15px 10px;
  flex: 1;
}

.app-components-Calendar-___Calendar-module__currentDay {
  font-size: 22px;
  font-weight: 600;
}

.app-components-Calendar-___Calendar-module__currentYear {
  font-weight: bold;
  opacity: 0.7;
}

.app-components-Calendar-___Calendar-module__calendar {
  background-color: white;
  display: flex;
  flex-direction: column;
}

.app-components-Calendar-___Calendar-module__selectMonth {
  display: flex;
  align-items: center;
  padding: 10px 25px;
  color: var(--colors-blackLight);
}

.app-components-Calendar-___Calendar-module__daysName {
  display: flex;
  padding: 10px;
}

.app-components-Calendar-___Calendar-module__dayName {
  color: var(--colors-grey);
  width: 45px;
  text-align: center;
}

.app-components-Calendar-___Calendar-module__weeks {
  display: flex;
  flex-direction: column;
}

.app-components-Calendar-___Calendar-module__weeks > div:last-child {
  margin-bottom: 15px;
}

.app-components-Calendar-___Calendar-module__months {
  border-radius: 3px;
  padding: 5px;
  font-size: 16px;
  text-transform: capitalize;
  cursor: pointer;
}

.app-components-Calendar-___Calendar-module__months:hover {
  background-color: var(--colors-yuzu-primaryColorLight);
}

.app-components-Calendar-___Calendar-module__months.app-components-Calendar-___Calendar-module__selected {
  background-color: var(--colors-yuzu-primaryColor);
  color: #ffffff;
  font-weight: bold;
  cursor: default;
}

.app-components-Calendar-___Calendar-module__week {
  display: flex;
  padding-right: 10px;
  padding-left: 10px;
  border-top: 1px solid rgba(0, 0, 0, 0.05);
  cursor: pointer;
}

.app-components-Calendar-___Calendar-module__week.app-components-Calendar-___Calendar-module__renderWeek:hover {
    background-color: var(--colors-mainColorMedium);
    background-size: 100% 20px;
    color: var(--colors-white);
  }

.app-components-Calendar-___Calendar-module__week.app-components-Calendar-___Calendar-module__selectedWeek {
    background-color: var(--colors-yuzu-primaryColorLight);
    background-size: 100% 20px;
  }

.app-components-Calendar-___Calendar-module__day {
  width: 32px;
  text-align: center;
  color: var(--colors-blackLight);
  margin: 2px 5px;
  line-height: 32px;
}

.app-components-Calendar-___Calendar-module__day.app-components-Calendar-___Calendar-module__daySelectMode {
    cursor: pointer;
  }

.app-components-Calendar-___Calendar-module__day.app-components-Calendar-___Calendar-module__notInCurrentMonth {
    color: var(--colors-greyLight);
  }

.app-components-Calendar-___Calendar-module__day.app-components-Calendar-___Calendar-module__isCurrentDay {
    background-color: rgba(0, 0, 0, 0.1);
    color: '#ffffff';
    border-radius: 5px;
  }

.app-components-Calendar-___Calendar-module__day.app-components-Calendar-___Calendar-module__isSelectedDay.app-components-Calendar-___Calendar-module__daySelectMode {
    background-color: var(--colors-yuzu-primaryColor);
    border-radius: 50%;
    margin-top: 5px;
    color: var(--colors-white);
  }

.app-components-Calendar-___Calendar-module__arrow {
  color: var(--colors-blackLight);
  cursor: pointer;
  padding: 8px 15px;
  border-radius: 5px;
}

.app-components-Calendar-___Calendar-module__arrow:hover {
    color: var(--colors-white);
    background-color: var(--colors-yuzu-primaryColor);
  }
`, "",{"version":3,"sources":["webpack://./app/components/Calendar/Calendar.module.scss"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,yBAAiB;KAAjB,sBAAiB;UAAjB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,4BAA4B;EAC5B,wBAAwB;EACxB,iDAAiD;EACjD,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,OAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,iDAAiD;EACjD,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yCAAyC;EACzC,eAAe;AAYjB;;AAVE;IACE,+CAA+C;IAC/C,0BAA0B;IAC1B,0BAA0B;EAC5B;;AAEA;IACE,sDAAsD;IACtD,0BAA0B;EAC5B;;AAGF;EACE,WAAW;EACX,kBAAkB;EAClB,+BAA+B;EAC/B,eAAe;EACf,iBAAiB;AAsBnB;;AApBE;IACE,eAAe;EACjB;;AAEA;IACE,8BAA8B;EAChC;;AAEA;IACE,oCAAoC;IACpC,gBAAgB;IAChB,kBAAkB;EACpB;;AAEA;IACE,iDAAiD;IACjD,kBAAkB;IAClB,eAAe;IACf,0BAA0B;EAC5B;;AAGF;EACE,+BAA+B;EAC/B,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AAMpB;;AAJE;IACE,0BAA0B;IAC1B,iDAAiD;EACnD","sourcesContent":[".container {\n  width: 314px;\n  user-select: none;\n  overflow: hidden;\n}\n\n.header {\n  display: flex;\n  /* flex-direction: column; */\n  /* padding: 15px 25px; */\n  background-color: var(--colors-yuzu-primaryColor);\n  color: var(--colors-yuzu-black);\n}\n\n.headerDate {\n  display: flex;\n  flex-direction: column;\n  padding: 15px 10px;\n  flex: 1;\n}\n\n.currentDay {\n  font-size: 22px;\n  font-weight: 600;\n}\n\n.currentYear {\n  font-weight: bold;\n  opacity: 0.7;\n}\n\n.calendar {\n  background-color: white;\n  display: flex;\n  flex-direction: column;\n}\n\n.selectMonth {\n  display: flex;\n  align-items: center;\n  padding: 10px 25px;\n  color: var(--colors-blackLight);\n}\n\n.daysName {\n  display: flex;\n  padding: 10px;\n}\n\n.dayName {\n  color: var(--colors-grey);\n  width: 45px;\n  text-align: center;\n}\n\n.weeks {\n  display: flex;\n  flex-direction: column;\n}\n\n.weeks > div:last-child {\n  margin-bottom: 15px;\n}\n\n.months {\n  border-radius: 3px;\n  padding: 5px;\n  font-size: 16px;\n  text-transform: capitalize;\n  cursor: pointer;\n}\n\n.months:hover {\n  background-color: var(--colors-yuzu-primaryColorLight);\n}\n\n.months.selected {\n  background-color: var(--colors-yuzu-primaryColor);\n  color: #ffffff;\n  font-weight: bold;\n  cursor: default;\n}\n\n.week {\n  display: flex;\n  padding-right: 10px;\n  padding-left: 10px;\n  border-top: 1px solid rgba(0, 0, 0, 0.05);\n  cursor: pointer;\n\n  &.renderWeek:hover {\n    background-color: var(--colors-mainColorMedium);\n    background-size: 100% 20px;\n    color: var(--colors-white);\n  }\n\n  &.selectedWeek {\n    background-color: var(--colors-yuzu-primaryColorLight);\n    background-size: 100% 20px;\n  }\n}\n\n.day {\n  width: 32px;\n  text-align: center;\n  color: var(--colors-blackLight);\n  margin: 2px 5px;\n  line-height: 32px;\n\n  &.daySelectMode {\n    cursor: pointer;\n  }\n\n  &.notInCurrentMonth {\n    color: var(--colors-greyLight);\n  }\n\n  &.isCurrentDay {\n    background-color: rgba(0, 0, 0, 0.1);\n    color: '#ffffff';\n    border-radius: 5px;\n  }\n\n  &.isSelectedDay.daySelectMode {\n    background-color: var(--colors-yuzu-primaryColor);\n    border-radius: 50%;\n    margin-top: 5px;\n    color: var(--colors-white);\n  }\n}\n\n.arrow {\n  color: var(--colors-blackLight);\n  cursor: pointer;\n  padding: 8px 15px;\n  border-radius: 5px;\n\n  &:hover {\n    color: var(--colors-white);\n    background-color: var(--colors-yuzu-primaryColor);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `app-components-Calendar-___Calendar-module__container`,
	"header": `app-components-Calendar-___Calendar-module__header`,
	"headerDate": `app-components-Calendar-___Calendar-module__headerDate`,
	"currentDay": `app-components-Calendar-___Calendar-module__currentDay`,
	"currentYear": `app-components-Calendar-___Calendar-module__currentYear`,
	"calendar": `app-components-Calendar-___Calendar-module__calendar`,
	"selectMonth": `app-components-Calendar-___Calendar-module__selectMonth`,
	"daysName": `app-components-Calendar-___Calendar-module__daysName`,
	"dayName": `app-components-Calendar-___Calendar-module__dayName`,
	"weeks": `app-components-Calendar-___Calendar-module__weeks`,
	"months": `app-components-Calendar-___Calendar-module__months`,
	"selected": `app-components-Calendar-___Calendar-module__selected`,
	"week": `app-components-Calendar-___Calendar-module__week`,
	"renderWeek": `app-components-Calendar-___Calendar-module__renderWeek`,
	"selectedWeek": `app-components-Calendar-___Calendar-module__selectedWeek`,
	"day": `app-components-Calendar-___Calendar-module__day`,
	"daySelectMode": `app-components-Calendar-___Calendar-module__daySelectMode`,
	"notInCurrentMonth": `app-components-Calendar-___Calendar-module__notInCurrentMonth`,
	"isCurrentDay": `app-components-Calendar-___Calendar-module__isCurrentDay`,
	"isSelectedDay": `app-components-Calendar-___Calendar-module__isSelectedDay`,
	"arrow": `app-components-Calendar-___Calendar-module__arrow`
};
export default ___CSS_LOADER_EXPORT___;
